<template>
  <div class="row">
    <div class="col-md-4 reports-tab-container">
      <div class="row">
        <div class="col-md-8">
          <label class="report-label">{{ $t('reports.invoices.date_range') }}</label>
          <base-select
            v-model="selectedRange"
            :options="dateRange"
            :allow-empty="false"
            :show-labels="false"
            @input="onChangeDateRange"
          />
          <span v-if="$v.range.$error && !$v.range.required" class="text-danger"> {{ $t('validation.required') }} </span>
        </div>
      </div>
      <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.invoices.from_date') }}</label>
          <base-date-picker
            v-model="formData.due_from_date"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.due_from_date.$touch()"
            @input="setRangeToCustom"
          />
        </div>
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.invoices.to_date') }}</label>
          <base-date-picker
            v-model="formData.due_to_date"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.due_to_date.$touch()"
            @input="setRangeToCustom"
          />
        </div>
      </div>
      <!-- Dropdowns for user type Super Admin -->
      <div v-if="userType == 'super_admin'" class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="form-label">{{ $tc('data_exports.reports.suppliers') }}</label>
          <base-select
            v-model="formData.company_id"
            :options="users"
            :group-select="false"
            :searchable="true"
            :show-labels="false"
            :placeholder="$t('suppliers.select_a_supplier')"
            group-values="options"
            group-label="label"
            track-by="id"
            label="name"
          />
        </div>
        <div class="col-md-6 report-field-container">
          <label class="form-label">{{ $tc('data_exports.reports.buyers') }}</label>
          <base-select
            v-model="formData.buyer_company_id"
            :options="buyers"
            :group-select="false"
            :searchable="true"
            :show-labels="false"
            :placeholder="$t('clients.select_a_buyer')"
            group-values="options"
            group-label="label"
            track-by="id"
            label="name"
          />
        </div>
      </div>

      <div class="row report-fields-container">

        <!-- Buyer dropdown for user type supplier -->
        <div
          v-if="userType == 'supplier'"
          class="col-md-6 report-field-container"
        >
        <label class="form-label">{{ $tc('data_exports.reports.buyers') }}</label>
          <base-select
            v-model="formData.customer_id"
            :options="customers"
            :group-select="false"
            :searchable="true"
            :show-labels="false"
            :placeholder="$t('clients.select_a_buyer')"
            group-values="options"
            group-label="label"
            track-by="id"
            label="name"
          />
        </div>
        <!-- Banks/Funder dropdown for supplier and Buyer -->
        <div
          v-if=" userType == 'supplier'"
          class="col-md-6 report-field-container"
        >
          <label class="form-label">{{
            $tc("reports.disbursement.bank")
          }}</label>
          <base-select
            v-model="formData.funder_id"
            :options="banks"
            :group-select="false"
            :searchable="true"
            :show-labels="false"
            :placeholder="$t('reports.disbursement.select_a_bank')"
            group-values="options"
            group-label="label"
            track-by="id"
            label="name"
          />
        </div>
      </div>


      <!-- Dropdowns for user type Funder -->

      <div v-if="userType == 'funder'" class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="form-label">{{ $tc('data_exports.reports.buyers') }}</label>
          <base-select
            v-model="formData.customer_id"
            :options="customers"
            :group-select="false"
            :searchable="true"
            :show-labels="false"
            :placeholder="$t('clients.select_a_buyer')"
            group-values="options"
            group-label="label"
            track-by="id"
            label="name"
          />
        </div>
        <div class="col-md-6 report-field-container">
          <label class="form-label">{{ $tc('data_exports.reports.suppliers') }}</label>
          <base-select
            v-model="formData.user_id"
            :options="suppliers"
            :group-select="false"
            :searchable="true"
            :show-labels="false"
            :placeholder="$t('suppliers.select_a_supplier')"
            group-values="options"
            group-label="label"
            track-by="id"
            label="name"
          />
        </div>

      </div>


      <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.invoices.status') }}</label>
          <base-select
            v-model="selectedStatus"
            :options="statuses"
            :allow-empty="false"
            :show-labels="false"
            @input="onChangeStatus"
          />
        </div>
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.rtgs_chq_number') }}</label>
          <base-input
            v-model="formData.rtgs_chq_number"
            :placeholder="$t('reports.enter_rtgs_or_chq_number')"
            type="text"
          />
        </div>
      </div>
      <div class="row report-submit-button-container">
        <div class="col-md-6">
          <base-button outline color="theme" class="report-button" @click="getReports()">
            {{ $t('reports.update_report') }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="col-sm-8 reports-tab-container">
      <iframe :src="getReportUrl" class="reports-frame-style"/>
      <a class="base-button btn btn-primary btn-lg report-view-button" @click="viewReportsPDF">
        <font-awesome-icon icon="file-pdf" class="vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2" /> <span>{{ $t('reports.view_pdf') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      reportTypes: ['By Customer', 'By Item'],
      selectedType: 'By Customer',
      dateRange: [
        'Today',
        'This Week',
        'This Month',
        'This Quarter',
        'This Year',
        'Previous Week',
        'Previous Month',
        'Previous Quarter',
        'Previous Year',
        'Custom'
      ],
      selectedRange: 'This Month',
      statuses: [
        'All',
        'Paid',
        'Partially Paid',
        'Approved'
      ],
      selectedStatus: '',
      range: new Date(),
      formData: {
        due_from_date: moment().startOf('week').toString(),
        due_to_date: moment().endOf('week').toString(),
        status: '',
        company_id: null,
        buyer_company_id: null,
        rtgs_chq_number: '',
        customer_id: null,
        funder_id: null,
        user_id: null
      },
      url: null,
      supplierSiteURL: null,
      newFunderArray: [],
      newClientArray: [],
      newCustomerArray: [],
      userType: null,
      newBuyerAsCustomerArray: [],
      newBanksArray: [],
      newSuppliersArray: []
    }
  },

  validations: {
    range: {
      required
    },
    formData: {
    }
  },

  computed: {
    ...mapGetters('company', [
      'getSelectedCompany'
    ]),
    ...mapGetters('customer', [
      'customers'
    ]),
    ...mapGetters('supplier', [
      'suppliers'
    ]),
    getReportUrl () {
      return this.url
    },

    users: {
      get: function () {
        return [
          {
            label: 'Suppliers',
            isDisable: true,
            options: this.newCustomerArray
          }
        ]
      },
      set: function (val) {
        this.formData.company_id = val
      }
    },

    buyers: {
      get: function () {
        return [
          {
            label: 'Buyers',
            isDisable: true,
            options: this.newClientArray
          }
        ]
      },
      set: function (val) {
        this.formData.buyer_company_id = val
      }
    },

    customers: {
      get: function () {
        return [
          {
            label: 'Buyers',
            isDisable: true,
            options: this.newBuyerAsCustomerArray
          }
        ]
      },
      set: function (val) {
        this.formData.customer_id = val
      }
    },

    banks: {
      get: function () {
        return [
          {
            label: 'Banks',
            isDisable: true,
            options: this.newBanksArray
          }
        ]
      },
      set: function (val) {
        this.formData.funder_id = val
      }
    },

    suppliers: {
      get: function () {
        return [
          {
            label: 'Suppliers',
            isDisable: true,
            options: this.newSuppliersArray
          }
        ]
      },
      set: function (val) {
        this.formData.user_id = val
      }
    }

  },

  watch: {
    range (newRange) {
      this.formData.due_from_date = moment(newRange).startOf('year').toString()
      this.formData.due_to_date = moment(newRange).startOf('year').toString()
    },

    'formData.customer_id' (value) {
      this.formData.funder_id = ''
      if (this.userType == 'supplier') {
        if (value != null && value.id != 'all') {
          this.fetchBuyerBanks(value.id).then((response) => {
            let buyerBanksArray = Object.values(response.data.banks)
            let buyerBanks = []
            buyerBanksArray.map(row => {
              if (row.company_name != null) {
                buyerBanks.push({ id: row.id, name: row.company_name })
              }
            })
            this.newBanksArray = buyerBanks
          })
        } else {
          this.getBanksForSupplierAccount()
        }
      } else {
        this.formData.user_id = ''
        if (value != null && value.id != 'all') {
          this.fetchSuppliersFromBuyers(value.id).then((response) => {
            let suppliersArray = response.data.suppliers
            this.newSuppliersArray = suppliersArray.map(function (row) {
              return { id: row.id, name: row.company_name}
            })
          })
        } else {
          this.getSuppliers()
        }
      }
      this.getReports()
    },

    'formData.funder_id' (value) {
      this.getReports()
    },

    'formData.user_id' (value) {
      this.getReports()
    }

  },

  created () {
    let data = { pagination: 'no'}

    if (localStorage.getItem('role') == 'super_admin') {
      this.userType = 'super_admin'
      this.getBuyers()
      this.getSuppliers()
    }

    if (localStorage.getItem('account_type') == 'supplier' && localStorage.getItem('role') == 'admin'|| localStorage.getItem('role') == 'user') {
      this.userType = 'supplier'
      this.getBuyersForSupplierAccount()
      this.getBanksForSupplierAccount()
    }

    if (localStorage.getItem('account_type') == 'funder' && localStorage.getItem('role') == 'admin'|| localStorage.getItem('role') == 'user') {
      this.userType = 'funder'
      this.getSuppliers()
      this.getBuyersForFunder()
    }

  },

  mounted () {
    if (this.$route.path === '/super-admin/reports/payment-outstanding-report') {
      this.$router.push('/super-admin/reports/payment-outstanding-report')
    }
    this.supplierSiteURL = `/reports/payment-outstanding-report/${this.getSelectedCompany.unique_hash}`
    this.getInitialReport()
  },

  methods: {
    ...mapActions('supplier', [
      'fetchSuppliers',
      'fetchBuyerBanks'
    ]),

    ...mapActions('customer', [
      'fetchCustomers',
      'fetchCreateCustomer'
    ]),

    ...mapActions('profileSharing', [
      'loadProfileSharingData'
    ]),

    ...mapActions('funder', [
      'fetchBuyersForFunder',
      'fetchSuppliersFromBuyers'
    ]),

    async getSuppliers () {
      let res = await this.fetchSuppliers({ pagination: 'no', role: 'admin' })
      let suppliersArray = res.data.suppliers.data

      let selectAll = []
      selectAll.push({ id: 'all', name: 'Select All' })

      if (this.userType == 'funder') {
        suppliersArray.map(row => {
          if (row.company_name != null) {
            selectAll.push({ id: row.id, name: row.company_name })
          }
        })
        this.newSuppliersArray = selectAll
      } else {
        suppliersArray.map(row => {
          if (row.company_name != null) {
            selectAll.push({ id: row.company_id, name: row.company_name })
          }
        })
        this.newCustomerArray = selectAll
      }
    },

    async getBuyers () {
      let response = await this.fetchCreateCustomer()
      if (response.data.success) {
        this.newClientArray = response.data.achorAccountType.map(function (row) {
          return { id: row.default_company_id, name: row.name }
        })
      }
    },

    async getBuyersForSupplierAccount () {
      let response = await this.fetchCustomers()
      let buyersAsCustomers = response.data.customers.data
      let selectAll = []
      selectAll.push({ id: 'all', name: 'Select All' })
      buyersAsCustomers.map(function (row) {
        if (row.company_name != null) {
          selectAll.push({ id: row.id, name: row.name })
        }
      })
      this.newBuyerAsCustomerArray = selectAll
    },

    async getBanksForSupplierAccount () {
      let response = await this.loadProfileSharingData({pagination: 'no'})
      let bankArray = response.data.sharedProfileUsers
      let selectAll = []
      selectAll.push({ id: 'all', name: 'Select All' })
      bankArray.map(function (row) {
        if (row.company_name != null) {
          selectAll.push({id: row.id, name: row.company_name})
        }
      })
      this.newBanksArray = selectAll
    },

    async getBuyersForFunder () {
      await this.fetchBuyersForFunder().then((response) => {
        let buyersArray = response.data.buyers
        let selectAll = []
        selectAll.push({ id: 'all', name: 'Select All' })
        buyersArray.map(function (row) {
          if (row.company_name != null) {
            selectAll.push({ id: row.id, name: row.name })
          }
        })
        this.newBuyerAsCustomerArray = selectAll
      })
    },

    getThisDate (type, time) {
      return moment()[type](time).toString()
    },

    getPreDate (type, time) {
      return moment().subtract(1, time)[type](time).toString()
    },

    getFormattedDate (type, time, quarter = '', halfyearly = 0, onlyMonth = false) {
      if (time == 'isoWeek') {
        return moment()[type](time).format('DD')
      } else if (time == 'month' && onlyMonth == false) {
        return moment()[type](time).format('DD-MM')
      } else if (time == 'month' && onlyMonth == true) {
        return moment()[type](time).format('MMM')
      } else if (time == 'quarter') {
        return moment().quarter(quarter)[type](time).format('DD-MM')
      } else if (time == 'quarter' && halfyearly > 0) {
        return moment().quarter(quarter)[type](time).format('DD-MM')
      } else if (time == 'year') {
        return moment()[type](time).format('YYYY')
      }
    },

    onChangeDateRange () {
      switch (this.selectedRange) {
        case 'Today':
          this.formData.due_from_date = moment().toString()
          this.formData.due_to_date = moment().toString()
          break

        case 'This Week':
          this.formData.due_from_date = this.getThisDate('startOf', 'isoWeek')
          this.formData.due_to_date = this.getThisDate('endOf', 'isoWeek')
          break

        case 'This Month':
          this.formData.due_from_date = this.getThisDate('startOf', 'month')
          this.formData.due_to_date = this.getThisDate('endOf', 'month')
          break

        case 'This Quarter':
          this.formData.due_from_date = this.getThisDate('startOf', 'quarter')
          this.formData.due_to_date = this.getThisDate('endOf', 'quarter')
          break

        case 'This Year':
          this.formData.due_from_date = this.getThisDate('startOf', 'year')
          this.formData.due_to_date = this.getThisDate('endOf', 'year')
          break

        case 'Previous Week':
          this.formData.due_from_date = this.getPreDate('startOf', 'isoWeek')
          this.formData.due_to_date = this.getPreDate('endOf', 'isoWeek')
          break

        case 'Previous Month':
          this.formData.due_from_date = this.getPreDate('startOf', 'month')
          this.formData.due_to_date = this.getPreDate('endOf', 'month')
          break

        case 'Previous Quarter':
          this.formData.due_from_date = this.getPreDate('startOf', 'quarter')
          this.formData.due_to_date = this.getPreDate('endOf', 'quarter')
          break

        case 'Previous Year':
          this.formData.due_from_date = this.getPreDate('startOf', 'year')
          this.formData.due_to_date = this.getPreDate('endOf', 'year')
          break

        default:
          break
      }
    },

    onChangeStatus () {
      this.formData.status = this.selectedStatus
    },

    setRangeToCustom () {
      this.selectedRange = 'Custom'
    },

    async getInitialReport () {
      this.url = `${this.supplierSiteURL}?type=preapproved&due_from_date=${moment(this.formData.due_from_date).format('DD/MM/YYYY')}&due_to_date=${moment(this.formData.due_to_date).format('DD/MM/YYYY')}`
      return true
    },

    async viewReportsPDF () {
      let data = await this.getReports()
      window.open(this.getReportUrl, '_blank')
      return data
    },

    async getReports (isDownload = false) {
      this.$v.range.$touch()
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }

      this.url = `${this.supplierSiteURL}?type=preapproved&due_from_date=${moment(this.formData.due_from_date).format('DD/MM/YYYY')}&due_to_date=${moment(this.formData.due_to_date).format('DD/MM/YYYY')}`

      if (this.formData.company_id && this.formData.company_id.id !== 'all') {
        this.url += `&company_id=${this.formData.company_id.id}`
      }
      if (this.formData.buyer_company_id && this.formData.buyer_company_id != null) {
        this.url += `&buyer_company_id=${this.formData.buyer_company_id.id}`
      }
      if (this.formData.status && this.formData.status != null) {
        this.url += `&overall_status=${this.formData.status}`
      }

      if (this.formData.rtgs_chq_number && this.formData.rtgs_chq_number != null) {
        this.url += `&rtgs_number=${this.formData.rtgs_chq_number}`
      }

      // customer_id from the Buyers dropdown (For Supplier and Funder Admin Account)
      if (this.formData.customer_id && this.formData.customer_id != null && this.formData.customer_id.id != 'all') {
        this.url += `&customer_id=${this.formData.customer_id.id}`
      }

      // funder_id from the Banks dropdown (For Supplier Admin Account)
      if (this.formData.funder_id && this.formData.funder_id != null && this.formData.funder_id.id != 'all') {
        this.url += `&funder_id=${this.formData.funder_id.id}`
      }

      // user_id from the Supplier dropdown (For Funder Admin Account)
      if (this.formData.user_id && this.formData.user_id != null && this.formData.user_id.id != 'all') {
        this.url += `&user_id=${this.formData.user_id.id}`
      }

      return true
    },

    downloadReport () {
      if (!this.getReports()) {
        return false
      }

      window.open(this.getReportUrl + '&download=true')
      setTimeout(() => {
        this.url = `${this.supplierSiteURL}?type=preapproved&due_from_date=${moment(this.formData.due_from_date).format('DD/MM/YYYY')}&due_to_date=${moment(this.formData.due_to_date).format('DD/MM/YYYY')}`

        if (this.formData.company_id && this.formData.company_id.id !== 'all') {
          this.url += `&company_id=${this.formData.company_id.id}`
        }
        if (this.formData.buyer_company_id && this.formData.buyer_company_id != null) {
          this.url += `&buyer_company_id=${this.formData.buyer_company_id.id}`
        }
        if (this.formData.status && this.formData.status != null) {
          this.url += `&overall_status=${this.formData.status}`
        }

        if (this.formData.rtgs_chq_number && this.formData.rtgs_chq_number != null) {
          this.url += `&rtgs_number=${this.formData.rtgs_chq_number}`
        }

        // customer_id from the Buyers dropdown (For Supplier and Funder Admin Account)
        if (this.formData.customer_id && this.formData.customer_id != null && this.formData.customer_id.id != 'all') {
          this.url += `&customer_id=${this.formData.customer_id.id}`
        }

        // funder_id from the Banks dropdown (For Supplier Admin Account)
        if (this.formData.funder_id && this.formData.funder_id != null && this.formData.funder_id.id != 'all') {
          this.url += `&funder_id=${this.formData.funder_id.id}`
        }

        // user_id from the Supplier dropdown (For Funder Admin Account)
        if (this.formData.user_id && this.formData.user_id != null && this.formData.user_id.id != 'all') {
          this.url += `&user_id=${this.formData.user_id.id}`
        }

        return true
      }, 200)
    }
  }
}
</script>
